import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full p-6" }
const _hoisted_2 = { class: "w-full flex gap-5" }
const _hoisted_3 = { class: "flex-grow bg-white rounded-lg shadow p-6 mb-6" }
const _hoisted_4 = { class: "text-xl font-semibold mb-4" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded mb-4 flex items-center"
}
const _hoisted_8 = {
  key: 1,
  class: "bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4 flex items-center"
}
const _hoisted_9 = {
  key: 2,
  class: "bg-blue-50 border border-blue-200 text-blue-700 px-4 py-3 rounded mb-4"
}
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = {
  key: 0,
  class: "ml-7 mt-1 text-gray-500 text-sm"
}
const _hoisted_12 = {
  key: 3,
  class: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 flex items-center"
}
const _hoisted_13 = { class: "sticky-sidebar" }
const _hoisted_14 = { class: "h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ForecastingTemplateView = _resolveComponent("ForecastingTemplateView")!
  const _component_ChatbotInterface = _resolveComponent("ChatbotInterface")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "text-2xl font-bold mb-2" }, "Forecasting for Planners", -1)),
    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-muted-foreground mb-6" }, "Create and manage forecasting data for operational planning and resource allocation", -1)),
    _createVNode(_component_ForecastingTemplateView, {
      class: "mb-6",
      onQuarterChanged: _ctx.onQuarterChanged,
      documentDates: _ctx.quarterDocuments
    }, null, 8, ["onQuarterChanged", "documentDates"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, "Upload Report for Quarter " + _toDisplayString(_ctx.selectedQuarter), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("input", {
            type: "file",
            id: "excel-template",
            accept: ".xlsx, .xls, .csv",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
            class: "hidden",
            ref: "fileInput"
          }, null, 544),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.triggerFileUpload && _ctx.triggerFileUpload(...args))),
            class: "bg-blue-700 text-white px-4 py-2 rounded-md flex items-center",
            disabled: _ctx.isUploading
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              class: "h-5 w-5 mr-2",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
              })
            ], -1),
            _createTextVNode(" Upload Excel File ")
          ]), 8, _hoisted_6)
        ]),
        (_ctx.isUploading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[3] || (_cache[3] = [
              _createElementVNode("svg", {
                class: "animate-spin h-5 w-5 mr-2",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("circle", {
                  class: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  "stroke-width": "4"
                }),
                _createElementVNode("path", {
                  class: "opacity-75",
                  fill: "currentColor",
                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                })
              ], -1),
              _createElementVNode("span", null, "Processing file...", -1)
            ])))
          : _createCommentVNode("", true),
        (_ctx.uploadSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("svg", {
                class: "h-5 w-5 mr-2",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M5 13l4 4L19 7"
                })
              ], -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.uploadSuccess), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedFile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[5] || (_cache[5] = _createElementVNode("svg", {
                  class: "h-5 w-5 mr-2",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  })
                ], -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.selectedFile.name), 1)
              ]),
              (_ctx.documentDates && (_ctx.documentDates.updated_at || _ctx.documentDates.created_at))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_ctx.documentDates.updated_at || _ctx.documentDates.created_at)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.documentDates.updated_at ? 'Last updated' : 'Created') + ": " + _toDisplayString(_ctx.formatDate(new Date(_ctx.documentDates.updated_at || _ctx.documentDates.created_at || new Date().toISOString()))), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.uploadError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _cache[6] || (_cache[6] = _createElementVNode("svg", {
                class: "h-5 w-5 mr-2",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                })
              ], -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.uploadError instanceof Object && 'message' in _ctx.uploadError ? _ctx.uploadError.message : _ctx.uploadError), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (_ctx.userData && _ctx.userData?.id)
            ? (_openBlock(), _createBlock(_component_ChatbotInterface, {
                key: 0,
                userData: _ctx.userData,
                environment: _ctx.currentEnv,
                userId: _ctx.userData?.id,
                class: "h-full chatbot-container",
                style: {"min-width":"600px","max-width":"600px","position":"sticky","top":"0"}
              }, null, 8, ["userData", "environment", "userId"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}